import { render, staticRenderFns } from "./ph-webinar-detail.vue?vue&type=template&id=0a1dc88e&scoped=true"
import script from "./ph-webinar-detail.vue?vue&type=script&lang=js"
export * from "./ph-webinar-detail.vue?vue&type=script&lang=js"
import style0 from "./ph-webinar-detail.vue?vue&type=style&index=0&id=0a1dc88e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1dc88e",
  null
  
)

export default component.exports